import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { CreateNewAgentContent } from 'src/components/HomePageComponents/CreateNewAgent/CreateNewAgentContent';

const CrossIcon = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 37.6923V32.3077H32.3077V0H37.6923V32.3077H70V37.6923H37.6923V70H32.3077V37.6923H0Z"
        fill="#389d61b3"
        className={'transition-all group-hover:fill-[#389d61e6]'}
      />
    </svg>
  );
};

export const CreateNewAgentCardModal = ({ disabled = false }) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <button>
          <div className="group flex flex-col relative h-full justify-center border border-[#389d6133] hover:border-[#389d6180] rounded-sm-5  hover:shadow-[0_3px_4px_0_#37684b59] transition-all">
            <div className="flex justify-center items-center w-full p-5 py-[110px]">
              <CrossIcon />
            </div>
          </div>
        </button>
      </DialogTrigger>
      <DialogContent className="laptop:max-w-[750px]">
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Create New AI Agent
          </DialogTitle>
        </DialogHeader>
        <div>
          <CreateNewAgentContent close={closePopup} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
